import { render, staticRenderFns } from "./TextOption.vue?vue&type=template&id=1202b625"
import script from "./TextOption.vue?vue&type=script&lang=js"
export * from "./TextOption.vue?vue&type=script&lang=js"
import style0 from "./TextOption.vue?vue&type=style&index=0&id=1202b625&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports